import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';

export const doesFulfillmentPlanNeedServiceMappingApplied = (fulfillmentPlan) => {
  if (!fulfillmentPlan) {
    return false;
  }

  const { serviceId, packages } = fulfillmentPlan;

  const isFulfillmentPlanAwaitingShipment = FulfillmentPlanOrderGridStatus.AwaitingShipment.name === fulfillmentPlan.orderGridStatus;
  const isFulfillmentPlanOnHold = FulfillmentPlanOrderGridStatus.OnHold.name === fulfillmentPlan.orderGridStatus;
  const isServicePopulated = !!serviceId;
  const onePackageObjectExists = Array.isArray(packages) && !!packages.length;
  const arePackagesPopulated = !!packages && packages.length > 0 && packages.some((pkg) => !!pkg && !!pkg.packageTypeId);
  return (
    (isFulfillmentPlanAwaitingShipment || isFulfillmentPlanOnHold) && !isServicePopulated && !arePackagesPopulated && onePackageObjectExists
  );
};
